import { render } from "./LogoutModal.vue?vue&type=template&id=b94ddd38&scoped=true"
import script from "./LogoutModal.vue?vue&type=script&lang=js"
export * from "./LogoutModal.vue?vue&type=script&lang=js"

import "./LogoutModal.vue?vue&type=style&index=0&id=b94ddd38&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b94ddd38"]])

export default __exports__